import React, { useEffect, useState, useRef } from "react";
import stakelogo from "../../assets/images/stake-logo.svg";
import logo from "../../assets/images/main-logo.svg";
import questionMarkIcon from "../../assets/Task/ReferImg.png";
import colorl from "../../assets/images/meme-logo.png";
import stakepoints from "../stakepoints/stakepoints";
import "./PhasePage.css";
import { weekRewards, stakeRewards, getUserDetails1 } from "../../apis/user";
import useUserInfo from "../../Hooks/useUserInfo";
import Menu from "../menu/menu";
import Tv from "../Tv/Tv";
// import cancelIcon from "../../assets/images/close-button.svg";
import cancelIcon from "../../assets/Task/cancelicon.svg";
import { useAudio } from "../../Providers/AudioProvider";
import { logPageView } from "../../components/analytics";

const PhasePage = () => {
  const { watchScreen, userDetails, updateUserInfo, updatewatchScreenInfo } =
    useUserInfo();
  const userId = userDetails?.userDetails?.telegramId;
  const [currentLevel, setCurrentLevel] = useState(userDetails?.currentPhase);
  const [TotalRewards, setTotalRewards] = useState(0);
  const [balanceRewards, setbalanceRewards] = useState(0);
  const [totalPhaseRewards, setTotalPhaseRewards] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const formatNumber = (num) => {
    if (num >= 1000000) return Math.floor(num / 100000) / 10 + "M";
    if (num >= 1000) return Math.floor(num / 100) / 10 + "k";
    return num;
  };
  const [stakeDetails, setStakeDetails] = useState({});
  const [currentStake, setCurrentStake] = useState([]);
  const [error, setError] = useState(null); // State to handle errors
  const [loading, setLoading] = useState(true); // State to indicate loading
  const playClick = useAudio();
  const [stakingInProgress, setStakingInProgress] = useState({}); // Add this state at the top with other states
  useEffect(() => {
    logPageView("StakePage", "Stake Page");
  }, []);
  const week = {
    1: "week1",
    2: "week2",
    3: "week3",
    4: "week4",
    5: "week5",
    6: "week6",
    7: "week7",
    8: "week8",
    9: "week9",
    10: "week10",
  };
  const scrollableRef = useRef(null);
  useEffect(() => {
    const preventTouchScroll = (event) => {
      // Allow scrolling only for the scrollable div
      if (!scrollableRef.current.contains(event.target)) {
        event.preventDefault();
      }
    };
    // Add the event listener
    document.addEventListener("touchmove", preventTouchScroll, {
      passive: false,
    });
    // Cleanup the event listener
    return () => {
      document.removeEventListener("touchmove", preventTouchScroll);
    };
  }, []);

  const fetchRewards = async (currentPhase) => {
    try {
      const data = {
        phase: currentPhase ? currentPhase : currentLevel,
      }; // Replace with actual data
      const response = await weekRewards(data); // Call the weekRewards function
      setIsLoading(false);
      setTotalPhaseRewards(response?.totalPhaseRewards);
      setbalanceRewards(response?.totalRewards);
      setCurrentStake(response?.dailyRewards); // Store the response in state
    } catch (err) {
      setError(err.message); // Handle errors
    } finally {
      setIsLoading(false); // Update loading state
    }
  };

  useEffect(() => {
    fetchRewards(); // Fetch rewards on component mount
    localStorage.setItem(
      `pointDetails_${userId}`,
      JSON.stringify({
        tapPoints: 0,
        watchSec: 0,
        boosterPoints: 0,
        booster: [0],
        count:0,
      })
    );
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
  }, []);

  useEffect(() => {
    // const value = currentStake?.rewardsForWeek?.reduce((acc, item) => {
    //   return item.userStaking ? acc + item.balanceRewards : acc;
    // }, 0);
    const FilterStake = currentStake?.filter((el) => el?.userStaking == true);
    const totalRewardsSum = FilterStake?.reduce(
      (sum, item) => sum + item.dailyEarnedRewards,
      0
    );
    setTotalRewards(totalRewardsSum / 2);
  }, [currentStake]);
  const updateStakeRewards = async (id) => { // Made function async
    playClick();
    setStakingInProgress(prev => ({ ...prev, [id]: true })); // Set loading for specific button
    setIsNextLoading(true);
    try {
      const res = await stakeRewards({ stakingId: String(id) }); // Added await
      if (res) {
        setTimeout(() => {
          fetchRewards();
        }, 1500);
      }
      const FilterStake = currentStake?.filter((el) => el?.userStaking == true);
      const totalRewardsSum = FilterStake?.reduce(
        (sum, item) => sum + item.dailyEarnedRewards,
        0
      );
      setTotalRewards(totalRewardsSum / 2);
    } finally {
      setIsNextLoading(false);
      setStakingInProgress(prev => ({ ...prev, [id]: false })); // Reset loading state
    }
  };
  const getUserDetailsOnly = async () => {
    let userDetails1;
    try {
      userDetails1 = await getUserDetails1(
        userDetails?.userDetails?.telegramId
      );
    } catch (error) {
      console.error("Error in updating or fetching user details:", error);
    }
    // Update state after both async calls are completed
    if (userDetails) {
      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails1,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails1?.boosters,
        totalReward: userDetails1?.balanceRewards,
        tapPoints: 0,
        booster: false,
        boosterSec: 0,
        boosterPoints: 0,
        boosterDetails: {},
        watchSec: 0,
      }));
    }
    return userDetails;
  };
  const goToThePage = (component, name) => {
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: name,
      lastComponent: userDetails.currentComponent,
      lastComponentText: userDetails.currentComponentText,
      centerCount: userDetails.centerCount + 1,
      isMenu: false,
    }));
  };
  const toogleMenu = () => {
    if (!watchScreen.booster) {
      const data = getUserDetailsOnly().then(() => {
        updateUserInfo((prev) => ({
          ...prev,
          isPlay: false,
          currentComponent: Tv,
          currentComponentText: "TVPage",
          lastComponent: userDetails?.userDetails.currentComponent,
          lastComponentText: userDetails?.userDetails.currentComponentText,
          isMenu: true,
          menuCount: userDetails?.userDetails?.menuCount + 1,
        }));
        // goToThePage(Battle, "BattlePage");
      });
    } else {
      goToThePage(Tv, "TVPage");
    }
    playClick();
  };

  const [isNextLoading, setIsNextLoading] = useState(false);
  const PrevFunct = async () => {
    if (currentLevel <= 1) return;
    playClick();
    setIsNextLoading(true);
    try {
      setCurrentLevel((prev) => prev - 1);
      await fetchRewards(currentLevel - 1);
    } finally {
      setIsNextLoading(false);
    }
  };
  const NextFunct = async () => {
    if (userDetails?.currentPhase <= currentLevel) return;
    playClick();
    setIsNextLoading(true);
    try {
      setCurrentLevel((prev) => prev + 1);
      await fetchRewards(currentLevel + 1);
    } finally {
      setIsNextLoading(false);
    }
  };
  const FindDate = new Date(userDetails?.userDetails?.lastLogin);
  const formattedDate = FindDate?.toISOString().split("T")[0];
  const FormatCurrentDate = (date) => {
    // Convert to Date object
    const dateObject = new Date(date);

    // Extract year, month, and day
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(dateObject.getDate()).padStart(2, "0");

    // Combine into desired format
    const formattedCurrentDate = `${year}-${month}-${day}`;
    return formattedCurrentDate;
  };

  return (
    <>
     <img
            onClick={() => {
              toogleMenu(Tv, "Tv");
            }}
            src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
            className="cancel-imgpoints"
            style={{ cursor: "pointer", zIndex: 1000000, pointerEvents: "all" }}
          />
          <img
            onMouseEnter={() => {
              goToThePage(stakepoints, "stakepoints");
            }}
            src='https://d1ccopf5cw1hft.cloudfront.net/s3data/ReferImg.png'
            alt="Question Mark Icon"
            className="cancel-imgleaderboard1"
            style={{ marginLeft: "5px" }}
          />
      {isLoading ? (
        <div className="loaderstyle">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="info-img scroll">
        <div>
       
        </div>
          
          <div
            className="menupointer stuff-body1"
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              // marginTop: "15%",
              justifyContent: "center",
              flexDirection: "column",
              pointerEvents: "all",
            }}
          >
            {isNextLoading && (
              <div className="loaderstyle">
                <div className="spinner"></div>
              </div>
            )}

            <div>
              {/* Previous Arrow */}
              <div
                onClick={PrevFunct}
                className={currentLevel > 1 ? "arrows prevact" : "arrows prev"}
              ></div>
              {/* Next Arrow */}
              <div
                onClick={NextFunct}
                className={
                  userDetails?.currentPhase <= currentLevel ? "" : "arrows next"
                }
              ></div>
            </div>
            <div className="phase" ref={scrollableRef}>
              <div className="row phaseContainer">
                <div className="col-5">
                  <h1 className="phase-text">TOTAL TOKENS</h1>
                </div>
                <div className="col-7">
                  <h3 className="phase-point">
                    <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png'/> {(formatNumber(balanceRewards))}
                  </h3>
                </div>
              </div>
              <div className="row justify-content-center">
                <div
                  className="col-11 p4 stake-display justify-content-center"
                  style={{ padding: "5px" }}
                >
                  <div className="col-8">
                    <h2>Phase {currentLevel} Staked</h2>
                  </div>
                  <div className="col-4">
                    <p className="phase-para">
                      <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' style={{ width: "20px" }} />{" "}
                      {formatNumber(TotalRewards)}
                    </p>
                  </div>
                </div>
              </div>
              {currentStake?.map((item, index) => {
                return (
                  <div
                    className={`row mt10  phase-stuff ${
                      formattedDate == item?.date ? "phase-stuff-border" : ""
                    } `}
                    style={{ width: "100%" }}
                  >
                    <div className="col-2">
                      <div>
                        <h2 className="stake-days">
                          DAY
                          <h3 className="stake-color">{index + 1}</h3>
                        </h2>
                      </div>
                    </div>
                    <div className="col-7 stuff-text">
                      <p className="phase-para">
                        <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/stake-logo.svg' />{" "}
                        {formatNumber(item?.dailyEarnedRewards)}
                      </p>
                    </div>
                    <div className="col-3">
                      {item?.userStaking ? (
                        <button className="stuff-unclaim">STAKED</button>
                      ) : null}
                      {item?.dailyEarnedRewards === 0 ||
                      new Date(FormatCurrentDate(item?.createdAt)) >=
                        new Date(FormatCurrentDate(formattedDate)) ? (
                        <button className="stuff-unclaim">STAKE</button>
                      ) : null}
                      {!item?.userStaking &&
                      item?.dailyEarnedRewards > 0 &&
                      new Date(FormatCurrentDate(item?.createdAt)) <
                        new Date(FormatCurrentDate(formattedDate)) ? (
                        <button
                          onClick={() => {
                            updateStakeRewards(item._id);
                          }}
                          className="stuff-claim"
                          disabled={stakingInProgress[item._id]}
                        >
                          {stakingInProgress[item._id] ? (
                            <div className="button-spinner"></div>
                          ) : (
                            "STAKE"
                          )}
                        </button>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PhasePage;
